import { render } from "./imagenprimera_ingles.vue?vue&type=template&id=6426d9e4&scoped=true"
import script from "./imagenprimera_ingles.vue?vue&type=script&lang=js"
export * from "./imagenprimera_ingles.vue?vue&type=script&lang=js"

import "./imagenprimera_ingles.vue?vue&type=style&index=0&id=6426d9e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6426d9e4"]])

export default __exports__